module.exports = __webpack_public_path__ + "img/3.22c0cdc2.png";